import React, { useEffect, useRef, useState } from "react";
import { Form, Input, Button, Space, Typography } from "antd";
import { UserOutlined, LockOutlined, SafetyOutlined } from "@ant-design/icons";
import styles from "./LoginForm.css"; // 样式文件
import classNames from "classnames";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Api from "@/api/api";
import { getUUID, showDanger, showSuccess } from "@/utils";
import { useLoading } from "@/components/global-loading";
import cookie from "cookie";

const API_ENV = process.env.API_ENV; // dev or production

const { Link, Text } = Typography;

const LoginForm = () => {
    const [form] = Form.useForm();
    const history = useHistory();
    const captchaUuidRef = useRef();
    const [captchaUrl, setCaptchaUrl] = useState("");
    const { showLoading, hideLoading } = useLoading();

    useEffect(() => {
        localStorage.removeItem("userInfo");
        
        // 检查是否已有 xiaozhi_token（可能从 fdddy.com 登录后返回）
        const xiaozhi_token = cookie.parse(document.cookie)["xiaozhi_token"];
        console.log("[DEBUG] LoginForm loaded, API_ENV:", API_ENV);
        console.log("[DEBUG] LoginForm loaded, xiaozhi_token:", xiaozhi_token ? "exists" : "not found");
        console.log("[DEBUG] Current cookies:", document.cookie);
        
        if (xiaozhi_token) {
            // 如果已有 token，直接跳转到首页
            console.log("[DEBUG] Found xiaozhi_token, redirecting to home page");
            history.replace("/");
            return;
        }
        
        // 如果是生产环境且没有 token，跳转到 fdddy.com 进行登录
        if (API_ENV === "production") {
            console.log("[DEBUG] Production environment without token, redirecting to fdddy.com");
            window.location.href = "https://fdddy.com/course/#/";
            return;
        }
        
        // 开发环境：显示登录表单
        // localStorage.removeItem("token");
        fetchCaptcha();
    }, [history]);

    const fetchCaptcha = () => {
        showLoading();
        captchaUuidRef.current = getUUID();

        Api.user.getCaptcha(captchaUuidRef.current, (res) => {
            if (res.status === 200) {
                const blob = new Blob([res.data], { type: res.data.type });
                setCaptchaUrl(URL.createObjectURL(blob));
            } else {
                showDanger("验证码加载失败，点击刷新");
            }

            hideLoading();
        });
    };

    const handleLogin = (values) => {
        showLoading("登录中...");
        const bodyData = {
            username: values.username,
            password: values.password,
            captcha: values.captcha,
            captchaId: captchaUuidRef.current,
            areaCode: "+86",
            mobile: "",
        };
        Api.user.login(
            bodyData,
            ({ data }) => {
                hideLoading();
                if (data?.data?.token) {
                    showSuccess("登录成功！");
                    console.log('登录成功')
                    console.log(data.data.token)
                    // 正确设置 cookie
                    document.cookie = `xiaozhi_token=${data.data.token}; path=/`;
                    console.log("[DEBUG] xiaozhi_token set:", document.cookie);
                    // localStorage.setItem("token", data.data.token);
                    history.replace("/");
                } else {
                    showDanger(data.msg || "登录失败！");
                    fetchCaptcha();
                }
            },
            (err) => {
                hideLoading();
                showDanger(err.data.msg || "登录失败");
                if (
                    err.data != null &&
                    err.data.msg != null &&
                    err.data.msg.indexOf("图形验证码") > -1
                ) {
                    fetchCaptcha();
                }
            }
        );
        // localStorage.setItem("is_authenticated", true);
        // history.push("/");
    };

    return (
        <div className={styles.loginFormContainer}>
            <Form
                form={form}
                name="loginForm"
                onFinish={handleLogin}
                layout="vertical"
                size="large"
            >
                {/* 用户名输入框 */}
                <Form.Item
                    style={{ marginBottom: 20 }}
                    name="username"
                    rules={[{ required: true, message: "请输入用户名" }]}
                >
                    <Input
                        prefix={<UserOutlined className={styles.inputIcon} />}
                        placeholder="请输入用户名"
                        className={styles.customInput}
                        variant="borderless"
                    />
                </Form.Item>

                {/* 密码输入框 */}
                <Form.Item
                    style={{ marginBottom: 20 }}
                    name="password"
                    rules={[{ required: true, message: "请输入密码" }]}
                >
                    <Input.Password
                        prefix={<LockOutlined className={styles.inputIcon} />}
                        placeholder="请输入密码"
                        className={styles.customInput}
                        variant="borderless"
                    />
                </Form.Item>

                {/* 验证码输入框 */}
                <Form.Item
                    style={{ marginBottom: 20 }}
                    name="captcha"
                    rules={[{ required: true, message: "请输入验证码" }]}
                >
                    <div className={styles.captchaRow}>
                        <Input
                            prefix={
                                <SafetyOutlined className={styles.inputIcon} />
                            }
                            placeholder="请输入验证码"
                            className={classNames(
                                styles.customInput,
                                styles.captchaInput
                            )}
                            variant="borderless"
                        />
                        <div
                            className={styles.captchaDisplay}
                            onClick={fetchCaptcha}
                        >
                            {captchaUrl && (
                                <img
                                    src={captchaUrl}
                                    alt="验证码"
                                    style={{
                                        width: "100%",
                                        height: "auto",
                                        cursor: "pointer",
                                    }}
                                />
                            )}
                        </div>
                    </div>
                </Form.Item>

                {/* 注册链接 */}
                {/* <div className={styles.registerLink}>
                    <Link href="/register">新用户注册</Link>
                </div> */}

                {/* 登录按钮 */}
                <Form.Item>
                    <Button
                        type="primary"
                        htmlType="submit"
                        className={styles.loginButton}
                        block
                    >
                        登录
                    </Button>
                </Form.Item>

                {/* 用户协议 */}
                {/* <div className={styles.agreementText}>
                    <Text type="secondary">
                        登录即同意
                        <Link href="/user-agreement">《用户协议》</Link>和
                        <Link href="/privacy-policy">《隐私政策》</Link>
                    </Text>
                </div> */}
            </Form>
        </div>
    );
};

export default LoginForm;
